module.exports = __webpack_public_path__ + "img/5.2-物流与供应链管理不透明.f324f3c1.png";